"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _ConfigProvider = require("../config-provider/ConfigProvider");

var _zh_CN = _interopRequireDefault(require("../config-provider/locale/zh_CN"));

var defaultConfigData = {
  locale: _zh_CN.default
};

var ConfigReceiverWrapper = function ConfigReceiverWrapper(name, defaultConfig) {
  return function InnerWrapper(WrappedComponent) {
    var ConfigReceiver = function ConfigReceiver(props) {
      return /*#__PURE__*/_react.default.createElement(_ConfigProvider.ConfigContext.Consumer, null, function (_ref) {
        var locale = _ref.locale;
        var globalLocale = locale.locale ? locale : (defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.locale) || (defaultConfigData === null || defaultConfigData === void 0 ? void 0 : defaultConfigData.locale);
        var componentLocale = globalLocale[name || WrappedComponent.name];
        var localeCode = globalLocale.locale;
        var forwardedRef = props.forwardedRef,
            rest = (0, _objectWithoutProperties2.default)(props, ["forwardedRef"]);
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, rest, {
          ref: forwardedRef,
          locale: componentLocale,
          localeCode: localeCode
        }));
      });
    };

    var forwardRef = function forwardRef(props, ref) {
      return /*#__PURE__*/_react.default.createElement(ConfigReceiver, (0, _extends2.default)({}, props, {
        forwardedRef: ref
      }));
    };

    var ConfigReceiverWithRef = /*#__PURE__*/_react.default.forwardRef(forwardRef);

    (0, _hoistNonReactStatics.default)(ConfigReceiverWithRef, WrappedComponent);
    return ConfigReceiverWithRef;
  };
};

var _default = ConfigReceiverWrapper;
exports.default = _default;